import React from "react";

/**
 * Team Modals Component - All confirmation and action modals
 */
const TeamModals = ({
  showLeaveConfirm,
  showRejectConfirm,
  showApproveModal,
  showDeleteConfirm,
  showRemoveMemberConfirm,
  showSwapModal,
  isLeaving,
  isDeleting,
  isRemovingMember,
  isChangingMemberType,
  rejectTarget,
  approveTarget,
  removeMemberTarget,
  swapSource,
  swapTargetUserId,
  selectedMemberType,
  rosterSummary,
  getActiveMembersByType,
  onLeaveConfirm,
  onLeaveCancel,
  onRejectConfirm,
  onRejectCancel,
  onApproveConfirm,
  onApproveCancel,
  onApproveTypeChange,
  onDeleteConfirm,
  onDeleteCancel,
  onRemoveMemberConfirm,
  onRemoveMemberCancel,
  onSwapConfirm,
  onSwapCancel,
  onSwapTargetChange,
}) => {
  return (
    <>
      {/* Leave Confirm Modal */}
      {showLeaveConfirm && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Leave Team?</h3>
            </div>
            <p className="confirm-modal-text">
              Are you sure you want to leave this team? You can request to rejoin later if the team
              allows it.
            </p>
            <div className="confirm-modal-actions">
              <button
                type="button"
                className="confirm-btn cancel"
                onClick={onLeaveCancel}
                disabled={isLeaving}
              >
                Cancel
              </button>
              <button
                type="button"
                className="confirm-btn danger"
                onClick={onLeaveConfirm}
                disabled={isLeaving}
              >
                {isLeaving ? "Leaving..." : "Leave Team"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reject Request Modal */}
      {showRejectConfirm && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Reject Request?</h3>
            </div>
            <p className="confirm-modal-text">
              Are you sure you want to reject
              {rejectTarget?.username ? ` ${rejectTarget.username}` : " this user"}'s request to
              join?
            </p>
            <div className="confirm-modal-actions">
              <button type="button" className="confirm-btn cancel" onClick={onRejectCancel}>
                Cancel
              </button>
              <button type="button" className="confirm-btn danger" onClick={onRejectConfirm}>
                Reject Request
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Approve Request Modal */}
      {showApproveModal && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Approve Request</h3>
            </div>
            <div className="confirm-modal-text" style={{ textAlign: "left", marginBottom: "20px" }}>
              <p style={{ marginBottom: "15px" }}>
                Approve {approveTarget?.username ? ` ${approveTarget.username}` : " this user"} to
                join the team as:
              </p>

              <div style={{ marginBottom: "10px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                    background: !selectedMemberType ? "rgba(96, 165, 250, 0.1)" : "transparent",
                    borderRadius: "8px",
                    border: !selectedMemberType ? "2px solid #60a5fa" : "2px solid transparent",
                  }}
                >
                  <input
                    type="radio"
                    name="memberType"
                    value=""
                    checked={!selectedMemberType}
                    onChange={() => onApproveTypeChange(null)}
                    style={{ marginRight: "10px" }}
                  />
                  <div>
                    <strong style={{ color: "#60a5fa" }}>Automatic</strong>
                    <div style={{ fontSize: "12px", color: "#999", marginTop: "4px" }}>
                      Starter if there is room, otherwise substitute
                    </div>
                  </div>
                </label>
              </div>

              <div style={{ marginBottom: "10px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                    background: selectedMemberType === "primary" ? "rgba(52, 211, 153, 0.1)" : "transparent",
                    borderRadius: "8px",
                    border: selectedMemberType === "primary" ? "2px solid #34d399" : "2px solid transparent",
                  }}
                >
                  <input
                    type="radio"
                    name="memberType"
                    value="primary"
                    checked={selectedMemberType === "primary"}
                    onChange={(e) => onApproveTypeChange(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <div>
                    <strong style={{ color: "#34d399" }}>🏃 Starter</strong>
                    <div style={{ fontSize: "12px", color: "#999", marginTop: "4px" }}>
                      Primary roster member (
                      {rosterSummary ? `${rosterSummary.primaryCount}/${rosterSummary.maxPrimary}` : "?/?"} slots)
                    </div>
                  </div>
                </label>
              </div>

              <div>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                    background: selectedMemberType === "substitute" ? "rgba(251, 146, 60, 0.1)" : "transparent",
                    borderRadius: "8px",
                    border: selectedMemberType === "substitute" ? "2px solid #fb923c" : "2px solid transparent",
                  }}
                >
                  <input
                    type="radio"
                    name="memberType"
                    value="substitute"
                    checked={selectedMemberType === "substitute"}
                    onChange={(e) => onApproveTypeChange(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <div>
                    <strong style={{ color: "#fb923c" }}>🔄 Substitute</strong>
                    <div style={{ fontSize: "12px", color: "#999", marginTop: "4px" }}>
                      Substitute member (
                      {rosterSummary
                        ? `${rosterSummary.substituteCount}/${rosterSummary.maxSubstitutes}`
                        : "?/?"}{" "}
                      slots)
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div className="confirm-modal-actions">
              <button type="button" className="confirm-btn cancel" onClick={onApproveCancel}>
                Cancel
              </button>
              <button type="button" className="confirm-btn success" onClick={onApproveConfirm}>
                Approve
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Team Modal */}
      {showDeleteConfirm && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Delete Team?</h3>
            </div>
            <p className="confirm-modal-text">
              Are you sure you want to delete this team? This action cannot be undone and will
              remove all team data, members, and statistics.
            </p>
            <div className="confirm-modal-actions">
              <button
                type="button"
                className="confirm-btn cancel"
                onClick={onDeleteCancel}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="confirm-btn danger"
                onClick={onDeleteConfirm}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete Team"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Remove Member Modal */}
      {showRemoveMemberConfirm && removeMemberTarget && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Remove Member?</h3>
            </div>
            <p className="confirm-modal-text">
              Are you sure you want to remove {removeMemberTarget.userName} from the team? They
              will be able to request to join again.
            </p>
            <div className="confirm-modal-actions">
              <button
                type="button"
                className="confirm-btn cancel"
                onClick={onRemoveMemberCancel}
                disabled={isRemovingMember}
              >
                Cancel
              </button>
              <button
                type="button"
                className="confirm-btn danger"
                onClick={onRemoveMemberConfirm}
                disabled={isRemovingMember}
              >
                {isRemovingMember ? "Removing..." : "Remove Member"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Swap Member Modal */}
      {showSwapModal && (
        <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
          <div className="confirm-modal">
            <div className="confirm-modal-header">
              <h3 className="confirm-modal-title">Swap Member Type</h3>
            </div>
            <div className="confirm-modal-text" style={{ textAlign: "left", marginBottom: "16px" }}>
              <p style={{ marginBottom: "12px" }}>
                Swap {swapSource?.name ? ` ${swapSource.name}` : " this member"} to
                {swapSource?.targetType === "primary" ? " starter" : " substitute"} with:
              </p>
              <select
                value={swapTargetUserId}
                onChange={(e) => onSwapTargetChange(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "6px",
                  background: "#1c1f26",
                  color: "#ffffff",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                }}
              >
                {swapSource?.targetType &&
                  getActiveMembersByType(swapSource.targetType).map((m) => (
                    <option key={m.user_id} value={m.user_id}>
                      {m.first_name} {m.last_name} (@{m.username})
                    </option>
                  ))}
              </select>
            </div>
            <div className="confirm-modal-actions">
              <button type="button" className="confirm-btn cancel" onClick={onSwapCancel}>
                Cancel
              </button>
              <button
                type="button"
                className="confirm-btn success"
                onClick={onSwapConfirm}
                disabled={isChangingMemberType}
              >
                Swap
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeamModals;
